<template>
  <div class="export-order">
    <div class="right-tip">当前运费余额: <span class="systemColor">{{ balance }}</span></div>
    <div class="box y-f y-f-jb">
      <div class="step">
        <div class="num">01</div>
        <div class="box-r">
          <div class="y-f y-f-fc">
            <img class="imgIcon" src="@/assets/images/icon/download.png" alt="">
            <div class="desp y-f y-f-fc">
              <span class="text">下载下方导入模板，按照模板表头填写，</span>
              <span class="text">检查重复行，避免重复下单</span>
            </div>
          </div>
          <div class="btn">
            <div class="chooose">
            <span class="yto-title1">批量导入模板</span><br/>
            <div class="tempDownload">
              <div class="parent-box active">
                <dt class="imgdt">
                  <svg-icon icon-class="icon_template_standard_def" class="tempIcon"></svg-icon>
                  <div class="normalColor">无发件人</div>
                </dt>
                <dt class="imgdt-bottom" @click="download('1')">下载模板</dt>
              </div>
              <div class="parent-box active">
                <dt class="imgdt">
                  <svg-icon icon-class="icon_template_standard_def" class="tempIcon"></svg-icon>
                  <div class="normalColor">有发件人</div>
                </dt>
                <dt class="imgdt-bottom" @click="download('2')">下载模板</dt>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
      <div class="step">
        <div class="num">02</div>
        <div class="box-r line">
          <div class="y-f y-f-fc">
            <img class="imgIcon" src="@/assets/images/icon/importAndCreate.png" alt="">
            <div class="desp y-f y-f-fc">
              <span class="text">确认余额充足后点击导入并创建订单按钮，</span>
              <span class="text">选择模板文件，稍等完成导入;</span>
              <span class="text">单次导入最多支持300条数据</span>
            </div>
          </div>
          <div class="btn">
            <span class="btn-span" @click="dialogVisible=true;">导入并创建订单</span>
          </div>
        </div>
      </div>
      <div class="step">
        <div class="num">03</div>
        <div class="box-r">
          <div class="y-f y-f-fc">
            <img class="imgIcon" src="@/assets/images/icon/downloadRecord.png" alt="">
            <div class="desp y-f y-f-fc">
              <span class="text">成功订单在订单列表查询，导入失败订单在导入记录中</span>
              <span class="text">下载结果文件查看，原因在最后一列</span>
            </div>
          </div>
          <div class="btn">
            <span class="btn-span"  @click="viewRecordFn">导入记录</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 导入文件弹层 -->
    <el-dialog
      title="请选择导入文件"
      :visible.sync="dialogVisible"
      width="670px"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <div v-if="importLoading" class="layer-import-wrapper"></div>
      <div>
        <el-form :model="form" label-width="120px" :rules="rules" ref="ruleForm">
          <el-form-item label="发件人地址" prop="addressId" >
            <el-select
              :disabled="isMultiAddress"
              :popper-append-to-body="false"
              popper-class="y-w-400"
              class="y-w-300 remote-style"
              v-model="form.addressId"
              filterable
              remote
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="addrLoading">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <span @click="showAddSenderInfo = true" class="systemColor y-ml-10 y-c-p">新增地址</span>
            <el-checkbox v-model="isMultiAddress" @change="checkedMultiAddressFn" class="y-ml-20">有发件人导入</el-checkbox>
          </el-form-item>
          <el-form-item label="取件时间" prop="reciveTime" >
            <selectTime
              ref="reciveTimeComponent"
              typeFlag="1"
              fromPage="importPage"
              placeholder="当前仅支持选择当日取"
              @selectedTime="selectedTimeFn"
            ></selectTime>
          </el-form-item>
          <el-form-item label="导入文件" prop="file" >
             <el-upload
              class="upload-demo"
              ref="upload"
              action=""
              accept=".xls,.xlsx"
              :limit="1"
              :on-exceed="overLimit"
              :on-change="handleChange"
              :on-remove="handleRemove"
              :file-list="fileList"
              :auto-upload="false"
              :before-upload="beforeUploadFile"
              :http-request="customUploadRequest"
            >
              <el-button slot="trigger" size="mini" class="border-btn">选择文件</el-button>
            </el-upload>
            <div style="position:relative;" v-if="importLoading">
              <div style="position:absolute;width:420px;left:0;top: 10px;">
                <el-alert
                    :show-icon="true"
                    :closable="false"
                    title="正在生成导入明细列表，需要一些时间，请不要关闭窗口！"
                    type="warning">
                </el-alert>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitUpload" :loading="importLoading">导入并创建</el-button>
      </span>
    </el-dialog>
    <!-- 导入记录 -->
    <recordList v-if="isShowRecord" :isShow="isShowRecord" @closeDialog="closeDialog"></recordList>
    <!-- 新增收货地址弹层 -->
    <senderInfo  :value="showAddSenderInfo" :isNotShowCompany="true" @close="closeReciverDialog"></senderInfo>
  </div>
</template>
<script>
import util, { downloadFileUrl } from '@/utils/util';
import recordList from './importRecordList.vue';
import selectTime from './selectTime';
import { getCustomerAddressApi } from '@/api/universal';
import { queryAccountInfoApi } from '@/api/waybillPrint/returnPickupPrint'
import { uploadImportFileApi, uploadSendAndReceiveImportFileApi } from '@/api/waybillPrint/sepecialOrderPrint';
import senderInfo from '@/views/baseInfo/printSetting/addressMaintenance/components/SenderInfo.vue'
export default {
  name: "export-order",
  components: {
    recordList,
    selectTime,
    senderInfo
  },
  props: {
    bindSellerInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    let valiAddressId = (rule, value, callback) => {
      if (this.isMultiAddress) {
        callback();
      } else if (!value && !this.options.length) {
        callback(new Error('请选维护常用地址'));
      } else if (!value) {
        callback(new Error('请选择收货地址'));
      } else {
        callback();
      }
    };
    return {
      data: {},
      fileList: [],
      importLoading: false,
      isShowRecord: false,
      dialogVisible: false,
      addrLoading: false,
      options: [],
      form: {
        addressId: '',
        reciveTime: [],
        file: []
      },
      rules: {
        addressId: [
          { validator: valiAddressId, trigger: 'change' },
        ],
        reciveTime: [
          { required: true, message: '请选择取件时间', trigger: ['blur', 'change'] },
        ],
        file: [
          { required: true, message: '请选择文件', trigger: ['blur', 'change'] },
        ],
      },
      balance: 0,
      showAddSenderInfo: false,

      isMultiAddress: false,
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(()=>{
          this.form.addressId = this.options.length ? this.options[0].id : '';
          this.form.reciveTime = this.$refs.reciveTimeComponent.selectedTime;
          this.isMultiAddress = false;
        })
      }
    }
  },
  methods: {
    handleClose() {
      this.fileList = [];
      this.dialogVisible = false;
      this.importLoading = false;
      this.form = {
        addressId: '',
        reciveTime: '',
        file: null
      }
      this.$refs.reciveTimeComponent.selectedTime = '';
      this.isMultiAddress = false;
    },
    submitUpload() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.isMultiAddress) {
            // 多收货地时，不需要收货地址--模板里有
          } else {
            // 单收货地时，需要收货地址
            let senderList = this.options.filter(o => { return o.id == this.form.addressId });
            if (senderList.length) {
              let item = senderList[0];
              this.data.sendName = item.name || '';
              this.data.sendMobile = item.mobile || '';
              this.data.sendPhone = item.phone || '';
              this.data.sendProvince = item.provinceName || '';
              this.data.sendCity = item.cityName || '';
              this.data.sendCountry = item.districtName || '';
              this.data.sendProvinceCode = item.provinceCode || '';
              this.data.sendCityCode = item.cityCode || '';
              this.data.sendCountryCode = item.districtCode || '';
              this.data.sendAddress = item.address || '';
            }
          }
          
          if (this.form.reciveTime.length) {
            this.data.dayFlag = this.form.reciveTime[0];
            this.data.timeRange = this.form.reciveTime[1];
            this.data.pickUpOrderType = '0';
          }
          this.data.bindBizStaffCode = this.bindSellerInfo.bindCode || '';
          this.data.groupId = this.userMess.groupId;
          this.data.userId = 'f69314be714d4aa4b9281ddecc7aff2d';
          this.$refs.upload.submit();
        } else {
          return false;
        }
      });
    },
    // 自定义上传请求：复用项目封装的 axios 实例（超时 120s 在 api 定义中配置），
    // 原 on-success/on-error 回调的处理逻辑已迁入此处
    customUploadRequest(params) {
      let formData = new FormData();
      formData.append('file', params.file, params.file.name);
      Object.keys(this.data).forEach(key => {
        formData.append(key, this.data[key]);
      });
      this.importLoading = true;
      let requestApi = this.isMultiAddress ? uploadSendAndReceiveImportFileApi : uploadImportFileApi;
      requestApi(formData).then((res) => {
        this.importLoading = false;
        this.fileList = [];
        this.form.file = [];
        if (res && (res.message === 'ok' || res.success)) {
          if (res.data.filePath) {
            // 部分导入成功
            this.importTipFn(res.data);
          } else {
            // 全部导入成功
            let tipHtml = res.data.message; //`本次上传 100 条订单，全部导入成功，请在订单列表查看`
            this.$confirm(tipHtml, '提示', {
              center: true,
              type: 'success',
              showCancelButton: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              confirmButtonText: '确 定',
            }).then(() => {
              // 导入成功后，回到订单列表页面
              this.$emit('goApplyOrder');
            });
          }
        } else if (res && res.message !== 'ok') {
          this.$message.error(res.message) // '导入数据超过限制！！ [1~500 条]'
        } else {
          this.$message.error('订单上传失败')
        }
        this.$refs['upload'].uploadFiles = [];
      }).catch((err) => {
        this.importLoading = false;
        this.data = {};
        this.fileList = [];
        this.form.file = [];
        this.$refs['upload'].uploadFiles = [];
        if (err && err.response) {
          // HTTP 状态错误（如 400/500）：全局响应拦截器已弹出具体错误提示
          return;
        }
        // 请求超时/无响应（响应拦截器对超时会抛出无 response 的错误）：
        // 导入由服务端异步处理，超时不代表失败，提示去导入记录查看结果
        this.$confirm(`导入完成，导入结果请在导入记录中查看`, '提示', {
          center: true,
          type: 'success',
          showCancelButton: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          confirmButtonText: '确 定',
        });
      });
    },
    // 获取发件人选择下拉列表
    getAddressList(query, remote){
      this.addrLoading = true;
      let params = {
        isSend: true,
        pageNo: 1,
        limit: 3000,
        name: '',
        telephone: '',
        address: '',
      };
      if(remote){
        params.remarks = query;
      }
      getCustomerAddressApi(params).then((res) => {
        this.addrLoading = false;
        if (res.data && res.data.hasOwnProperty('total')) {
          let items = res.data.list || [];
          items.forEach((val) => {
            val.value = val.id
            val.label = `${val.name} ${val.mobile ? val.mobile : val.phone} ${val.provinceName}${val.cityName}${val.districtName}${val.address}`
          });
          this.options = items;
          this.form.addressId = items.length ? items[0].id : '';
        } else {
          this.options = [];
          this.form.addressId = '';
        }
      }).catch(() => {
        this.addrLoading = false;
        this.options = [];
        this.form.addressId = '';
      });
    },
    remoteMethod(query) {
      if (query !== '') {
        this.getAddressList(query, true);
      }
    },
    // 下载模板
    download(type) {
      let dom = document.createElement('a');
      dom.download = '';
      if (type == '1') {
        dom.href = '/new/static/templates/无发件人导入模板.xls';  
      } else {
        dom.href = '/new/static/templates/有发件人导入模板.xls';
      }
      
      document.body.appendChild(dom);
      dom.click();
      dom.remove();
    },
    importTipFn(data) {
      // 导入
      let tipHtml = data.message; //`本次上传 100 条订单，校验通过 80 条， 20条校验不通过`
      this.$confirm(tipHtml, '提示', {
        dangerouslyUseHTMLString: true,
        center: true,
        type: 'warning',
        showCancelButton: false,
        confirmButtonText: '下载导入结果文件',
      }).then(() => {
        // 下载导入结果文件
        downloadFileUrl(util.picUrl + data.filePath);

        this.$nextTick(()=>{
          // 导入成功后，回到订单列表页面
          this.$emit('goApplyOrder');
        })
      });
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
      this.form.file = file;
    },
    // 超出文件个数限制
    overLimit() {
      this.$message.warning('一次只能上传一个文件！');
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.form.file = [];
    },
    beforeUploadFile(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 5MB!');
      }
      return isLt5M;
    },
    // 查看导入记录
    viewRecordFn() {
      this.isShowRecord = true;
    },
    closeDialog() {
      this.isShowRecord = false;
    },
    getAccountInfo() {
      this.balance = 0;
      queryAccountInfoApi({}).then(res => {
        if (res.status == 200 && res.data && res.data.list) {
          let list = res.data.list || [];
          let balance = list.length ? list[0].balance : 0;
          this.balance = balance;
        }
      })
    },
    selectedTimeFn(selectedTime) {
      this.form.reciveTime = selectedTime;
    },
    closeReciverDialog() {
      this.getAddressList();
      this.showAddSenderInfo = false;
    },
    checkedMultiAddressFn(val) {
      if (val) {
        this.form.addressId = '';
      } else {
        this.form.addressId = this.options.length ? this.options[0].id : '';
      }
    }
  },
  mounted() {
    this.getAddressList();
    this.getAccountInfo();
  },
};
</script>
<style lang="scss" scoped>
.export-order {
  background-color: #fff;
  border-radius: 20px;
  // width: 100%;
  // height: 100%;
  .right-tip {
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    text-align: right;
    padding-right: 20px;
  }
  .box {
    width: 80%;
    margin: 0 auto;
    margin-top: 8%;
    .step {
      width: 33%;
      // height: 391px;
      text-align: center;
      .num {
        width: 33px;
        height: 82px;
        margin: 0 auto;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 32px;
        color: #A1A1A1;
        line-height: 82px;
      }
      .imgIcon {
        width: 100px;
        height: 100px;
        margin: 0 auto;
      }
      .desp {
        height: 60px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #6D6D6D;
        line-height: 20px;
        margin-top: 15px;
        margin-bottom: 12px;
      }
      .btn {
        .btn-span {
          height: 32px;
          padding: 7px 13px;
          background: #653EB3;
          border-radius: 2px;
          color: #fff;
          font-size: 14px;
          cursor: pointer;
        }
        
      }
    }
    .box-r.line{
      border-left: 1px solid #F3F3F3;
      border-right: 1px solid #F3F3F3;
    }
  }
  .layer-import-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
  }
  .chooose {
    padding-left: 34px;
    .yto-title {
      color: #333;
      font-size: 16px;
      font-weight: 900;
    }
    .tempDownload {
      display: flex;
      justify-content: center;
      padding-top: 17px;
      padding-left: 25px;
      padding-bottom: 30px;
    }
  }
  .imgdt {
    position: relative;
    box-sizing: border-box;
    height:106px;
    text-align: center;
  }
  .imgdt-bottom {
    height: 29px;
    line-height: 29px;
    color: $gray;
    font-size: 14px;
    border-top: 1px solid $blue-import-border-style;
  }
  .parent-box {
    box-sizing: border-box;
    width: 116px;
    height: 136px;
    margin: 0 8px;
    border-radius: 3px;
    text-align: center;
    cursor: pointer;
    box-shadow: 0px 0px 10px 0px rgba(109, 140, 209, 0.12);
    border-radius: 3px;
    border: 1px solid $white;
  }
  .tempIcon {
    width: 31px!important;
    height: 36px!important;
    margin-top: 19px;
    margin-bottom: 15px;
    &:hover {
      color: #545c64;
    }
  }
  .normalColor {
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    color: $blue-style;
  }
  .parent-box:hover, .parent-box:active, .parent-box.active{
    box-shadow: 0px 2px 15px 0px rgba(109,140,209,0.12);
    border: 1px solid $blue-style;
    border-color: $blue-style;
    box-shadow: 0px 2px 15px 0px rgba(109, 140, 209, 0.12);
    .normalColor {
      color:$color-style;
    }
    .imgdt-bottom {
      background-color: $blue-style;
      color: $white;
    }
  }
}
/deep/ .el-dialog__footer {
  text-align: center;
}
</style>